import styled from '@emotion/styled';
import {FormControl, FormHelperText} from '@mui/material';
import React from 'react';

import {Info} from '@ELib/assets/images';
import {mixinFlexboxRow, mixinSVGIcon} from '@ELib/styles/mixins';

import {ESmallText} from '../EText';
import {ETooltip} from '../ETooltip';

import {ELabel} from './ELabel';
import {FlexColumnWrapper} from './FlexColumnWrapper';

type FormInputWrapperProps = {
  label?: string | React.ReactElement;
  labelInfo?: string;
  labelProps?: React.LabelHTMLAttributes<HTMLLabelElement>;
  bottomText?: string;
  error?: boolean;
  errorMessage?: string;
} & React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

export function FormInputWrapperLabel({
  label,
  labelInfo,
}: {
  label: string | React.ReactElement;
  labelInfo?: string;
}): React.ReactElement {
  if (!labelInfo) {
    return <>{label}</>;
  }

  return (
    <StyledLabelRow>
      {label}
      <ETooltip title={labelInfo}>
        <Info />
      </ETooltip>
    </StyledLabelRow>
  );
}

export const FormInputWrapper = ({
  label,
  labelProps,
  labelInfo,
  bottomText,
  error,
  errorMessage,
  children,
  ...htmlProps
}: React.PropsWithChildren<FormInputWrapperProps>): React.ReactElement => (
  <FlexColumnWrapper {...htmlProps}>
    {label && (
      <ELabel {...labelProps}>
        <FormInputWrapperLabel label={label} labelInfo={labelInfo} />
      </ELabel>
    )}

    <FormControl error={error}>
      {children}
      {bottomText ? (
        <ESmallText className='bottomText'>{bottomText}</ESmallText>
      ) : null}
      {error && Boolean(errorMessage) ? (
        <FormHelperText>{errorMessage}</FormHelperText>
      ) : null}
    </FormControl>
  </FlexColumnWrapper>
);

const StyledLabelRow = styled.div`
  ${mixinFlexboxRow}
  align-items: center;
  gap: var(--gutter-tiny);

  svg {
    ${mixinSVGIcon}
  }
`;
